/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowAUpLeftIcon20Light = forwardRef('ArrowAUpLeftIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M13.5 3a.5.5 0 0 1 0 1H5c-.09 0-.176.012-.26.034l11.614 11.612a.5.5 0 0 1-.708.708L4.034 4.74C4.012 4.824 4 4.911 4 5v8.5a.5.5 0 0 1-1 0V5a2 2 0 0 1 2-2h8.5Z" })));
});
